'use client';
import React, { PropsWithChildren } from 'react';

import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { theme } from '@components/mui/ThemeProvider';
import CloseIcon from '@mui/icons-material/Close';
import { If } from 'react-if';

const DIALOG_CONTENT_WIDTH = '620px';

interface Props {
  onClose: () => void;
  ariaLabelledby: string;
  hideCloseIcon?: boolean;
  // don't show the modal in full screen for mobile web
  disableMobileFullScreen?: boolean;
}

type DialogProps = React.ComponentProps<typeof Dialog>;

const Modal: React.FC<PropsWithChildren<Props & DialogProps>> = ({
  children,
  onClose,
  ariaLabelledby,
  hideCloseIcon = false,
  disableMobileFullScreen = false,
  ...props
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      {...props}
      aria-labelledby={ariaLabelledby}
      fullScreen={isMobile && !disableMobileFullScreen}
      maxWidth="md"
      onClose={onClose}
    >
      <If condition={!hideCloseIcon}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.neutral.dark,
          })}
        >
          <CloseIcon />
        </IconButton>
      </If>
      <DialogContent
        sx={{
          ...(!isMobile
            ? {
                minWidth: DIALOG_CONTENT_WIDTH,
              }
            : {}),
          overflowY: 'unset',
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
